import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={492}
    height={492}
    viewBox={'0 0 492 492'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#FFFFFF'}
      d="M46.406 321.555.5 304.9V1h247c0 144.62-27.039 79.57 36.957 224.782C360.312 397.905 454.609 436.439 490.5 483.243 273.248 526.676 73.986 376.003 46.406 321.555Z"
    />
  </Svg>
);
export default SvgComponent;
